const HorizontalPreview = ({list}) => {

    const normalizedData = {
        list: list
    }

    return normalizedData
}

export default HorizontalPreview